/** @format */

import template from './gb-edit-item-table-widget.html';
import './gb-edit-item-table-widget.scss';

import _ from 'lodash';

export const GbEditItemTableWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbEditTools: '^^',
        gbAddItemTableWidget: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbEditItemTableWidgetComponent {
        constructor($gbEditTableItemsDialog, $gbItem, $ccLoading, LoadingHelper) {
            'ngInject';

            this.$gbEditTableItemsDialog = $gbEditTableItemsDialog;
            this.$gbItem = $gbItem;

            this.listTypes = ['standard_table', 'compact_table'];
            this.gridTypes = ['tall_card'];

            this.loadingHelper = new LoadingHelper();
            this.isLoading = () => this.loadingHelper.isLoading();
            this.getLoadingMessage = () => this.loadingHelper.getFirstMessage();
            this.loadingWatcher = $ccLoading.bind(this.isLoading, this.getLoadingMessage);
        }

        $onInit() {
            this.setTableType();
        }

        getItems() {
            return this.$gbItem.cache.query({
                auction: this.gbApp.getAuctionUrl(),
                is_visible: true,
            });
        }

        editTableItems() {
            let data = {
                widget: this.widget,
                items: this.getItems(),
            };

            return this.$gbEditTableItemsDialog.show(data).then((hiddenUuids) => {
                this.widget.hidden_items = hiddenUuids;
                this.gbEditTools.saveWidget();
            });
        }

        isListTable() {
            return !!this.widget && this.listTypes.indexOf(this.widget.card_type) > -1;
        }

        isGridTable() {
            return !!this.widget && this.gridTypes.indexOf(this.widget.card_type) > -1;
        }

        setTableType() {
            if (this.isListTable()) {
                this.tableType = 'list';
            } else if (this.isGridTable()) {
                this.tableType = 'grid';
            }
        }

        setListDefaults() {
            _.assign(this.widget, this.gbAddItemTableWidget.listTableDefaults);

            this.gbEditTools.saveWidget();
        }

        setGridDefaults() {
            _.assign(this.widget, this.gbAddItemTableWidget.gridTableDefaults);

            this.gbEditTools.saveWidget();
        }

        onWidgetSaveChange() {
            const loader = this.loadingHelper.push('SAVING');
            this.gbEditTools.saveWidget().finally(() => {
                loader();
            });
        }
    },
};
